//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
import { flow, getEnv, getParent, getSnapshot, types } from "mobx-state-tree";

const BookingStore = types
  .model("BookingStore", {
    slug: types.optional(types.string, ""),
    walletBalance: types.optional(types.number, 0),
    currency: types.optional(types.string, "₦"),
    paymentMethod: types.optional(types.string, "online"),
    tuitionFee: types.optional(types.maybeNull(types.number), 0),
    totalDiscount: types.optional(types.number, 0),
    transportFare: types.optional(types.number, 0),
    distanceThreshold: types.optional(types.number, 20),
    farePerKM: types.optional(types.number, 25),
    monthsPaid: types.optional(types.number, 1),
    discountRemoved: types.optional(types.number, 0),
    couponDiscount: types.optional(types.number, 0),
    gatewayFee: types.optional(types.number, 0),
    discountCode: types.optional(types.string, ""),
    paidSpeakingFee: types.optional(types.boolean, false),
    timeSubmitted: types.maybeNull(types.string),
    actualAmountPaid: types.optional(types.maybeNull(types.number), 0),
  })
  .views((self) => {
    return {
      get isBillableDistance() {
        let parent: any = getParent(self, 1);
        let {
          lessonDetails: { lessonType },
          filters,
        } = parent.requestData;
        let delivery = Boolean(filters.delivery)
          ? filters.delivery
          : lessonType;

        return self.transportFare > 0 && delivery === "physical";
      },
      get hoursOfLesson() {
        let parent: any = getParent(self, 1);
        let {
          lessonDetails: { lessonSchedule },
        } = parent.requestData;
        return lessonSchedule ? lessonSchedule.lessonHours : "";
      },
      get daysRequested() {
        let parent: any = getParent(self, 1);
        let {
          lessonDetails: { lessonSchedule },
        } = parent.requestData;
        return lessonSchedule ? lessonSchedule.lessonDays : [];
      },
      get daysSelected() {
        let parent: any = getParent(self, 1);

        let daysSelected = [];
        parent.splitRequests
          .filter((split) => split.names.length > 0)
          .map((split) => daysSelected.push(...split.lessonDays));
        return [...new Set([...daysSelected])];
      },
      get totalTuition() {
        let parent: any = getParent(self, 1);
        let {
          tuitionFee = 0,
          transportFare = 0,
          totalDiscount = 0,
        } = parent.generatePaymentInfo();
        return tuitionFee + transportFare - totalDiscount;
      },
      get totalLessons() {
        let parent: any = getParent(self, 1);
        let { lessonPayments = [] } = parent.generatePaymentInfo();
        return lessonPayments.reduce((a, b) => a + b.lessons, 0);
      },
      get amountToBePaid() {
        return (
          this.totalTuition * self.monthsPaid -
          self.walletBalance +
          self.gatewayFee -
          self.discountRemoved
        );
      },
      get paymentInfo() {
        let pp: any = getParent(self, 1);
        let { generatePaymentInfo, splitRequests = [], slug } = pp;
        let { tuitionFee, totalLessons, totalDiscount, couponDiscount } =
          generatePaymentInfo();
        return {
          slug,
          walletBalance: self.walletBalance,
          tutors: splitRequests.map(({ selectedTutor }) => ({
            userId: selectedTutor.userId,
            subject: selectedTutor.subject.shortSummary,
            newTutorDiscount: selectedTutor.newTutorDiscount,
            distance: selectedTutor.distance || 0,
            firstName: selectedTutor.firstName,
            lastName: selectedTutor.lastName,
            photo: selectedTutor.photo,
          })),
          tuitionFee,
          totalLessons,
          totalDiscount,
          couponDiscount,
          distanceThreshold: self.distanceThreshold,
          farePerKM: self.farePerKM,
          currency: self.currency,
          monthsPaid: self.monthsPaid,
          discountRemoved: self.discountRemoved,
          gatewayFee: self.gatewayFee,
          timeSubmitted: self.timeSubmitted,
          discountCode: self.discountCode,
          actualAmountPaid: self.actualAmountPaid,
        };
      },
      get bookingDetails() {
        let pp: any = getParent(self, 1);
        let {
          requestData: { contactDetails },
          generatePaymentInfo,
          splitRequests,
        } = pp;
        let {
          lessonPayments = [],
          totalLessons = 0,
          totalTuition = 0,
        } = generatePaymentInfo();
        return {
          bookingId: self.slug,
          userInfo: {
            firstName: contactDetails.firstName,
            title: contactDetails.title,
            walletBalance: 0,
          },
          lessonInfo: {
            numberOfLessons: totalLessons,
            lessonAmount: totalTuition,
            selectedTutors: lessonPayments.map(
              ({ tutor, lessons, students, lessonFee }, i) => {
                return {
                  tutor,
                  subjects: splitRequests[i].subjectGroup,
                  lessons,
                  students,
                  lessonFee,
                };
              },
            ),
          },
        };
      },
      get speakingFee() {
        const oneTutorFee = 3000;
        const multipleTutorFee = 2500;
        const numberOfTutors =
          this.bookingDetails.lessonInfo.selectedTutors.length;
        if (numberOfTutors === 1) {
          return oneTutorFee;
        } else {
          return multipleTutorFee * numberOfTutors;
        }
      },
      // get lessonPayments() {
      //   let parent = getParent(self, 1);
      //   return self.splitRequests.map((tutor) => {
      //     return tutor.lessonPayments(
      //       parent.requestData,
      //       self.distanceThreshold,
      //       self.farePerKM
      //     );
      //   });
      // },
      // get bookingDetails() {
      //   let parent = getParent(self, 1);
      //   let {
      //     requestData: { contactDetails },
      //   } = parent;
      //   return {
      //     bookingId: self.slug,
      //     userInfo: {
      //       firstName: contactDetails.firstName,
      //       title: contactDetails.title,
      //       walletBalance: self.walletBalance,
      //     },
      //     lessonInfo: {
      //       numberOfLessons: this.totalLessons,
      //       lessonAmount: this.totalTuition,
      //       selectedTutors: this.lessonPayments.map(
      //         ({ tutor, lessons, students, lessonFee }, i) => {
      //           return {
      //             tutor,
      //             subjects: self.splitRequests[i].subjectGroup,
      //             lessons,
      //             students,
      //             lessonFee,
      //           };
      //         }
      //       ),
      //     },
      //   };
      // },
      // get speakingFee() {
      //   const oneTutorFee = 3000;
      //   const multipleTutorFee = 2500;
      //   const numberOfTutors =
      //     this.bookingDetails.lessonInfo.selectedTutors.length;
      //   if (numberOfTutors === 1) {
      //     return oneTutorFee;
      //   } else {
      //     return multipleTutorFee * numberOfTutors;
      //   }
      // },
    };
  })
  .actions((self) => {
    const updateBookingState = () => {
      if (self.timeSubmitted) {
        let futureDate = new Date(self.timeSubmitted);
        futureDate.setHours(futureDate.getHours() + 2);
        if (futureDate < new Date()) {
          self.totalDiscount = 0;
          self.couponDiscount = 0;
        }
      }
    };
    function calculateGateWay(baseValue) {
      let baseRate = 1.5 / 100;
      let additionalCharge = 100;
      // if (countryOfUser !== "Nigeria") {
      //   baseRate = 3.9 / 100;
      // }
      if (baseValue < 2500) {
        additionalCharge = 0;
      }
      let result = baseValue * baseRate + additionalCharge;
      if (result >= 2000) {
        result = 2000;
      }
      return Math.round(result);
    }
    const generateSpeakingInvoice = flow(
      function* generateSpeakingInvoice(amount) {
        let { adapter } = getEnv(self);
        const parent: any = getParent(self, 1);
        try {
          const response = yield adapter.generateSpeakingInvoice(
            amount + calculateGateWay(amount),
            self.paymentInfo,
            {
              ...parent.requestData,
              splitRequests: getSnapshot(parent.splitRequests),
            },
            "speaking",
          );
          return response;
        } catch (error) {
          throw error;
        }
      },
    );
    const onPayWithWallet = flow(function* onPayWithWallet() {
      let { adapter } = getEnv(self);
      if (self.walletBalance >= self.totalTuition) {
        try {
          let result = yield adapter.onPayWithWallet({
            slug: self.slug,
            amount: self.totalTuition,
          });
          return result;
        } catch (error) {
          throw error;
        }
      } else {
        throw "Error ";
      }
    });
    const generateInvoice = flow(function* generateInvoice(amount) {
      let { adapter } = getEnv(self);
      const parent: any = getParent(self, 1);
      self.gatewayFee = calculateGateWay(amount);
      self.actualAmountPaid = amount;
      try {
        const response = yield adapter.generateInvoice(
          Math.round(amount + self.gatewayFee),
          self.paymentInfo,
          {
            ...parent.requestData,
            splitRequests: getSnapshot(parent.splitRequests),
          },
        );
        return response;
      } catch (error) {
        throw error;
      }
    });
    return {
      updateBookingState,
      calculateGateWay,
      generateInvoice,
      onPayWithWallet,
      setPaidFee() {
        self.paidSpeakingFee = true;
      },
      generateSpeakingInvoice,
      multipleMonthDiscount({ value, discountRemoved }) {
        self.monthsPaid = value;
        self.discountRemoved = discountRemoved;
      },
    };
  });

export default BookingStore;
